// choices/vibeChoices.js
const vibeChoicesSrb = [
  {
    label: "Смиреност",

    value: "calm",
  },
  {
    label: "Активност",
    value: "active",
  },

  {
    label: "Удобност",
    value: "comfortable",
  },

  {
    label: "Елеганција",
    value: "elegant",
  },

  {
    label: "Креативност",
    value: "creative",
  },
];

export default vibeChoicesSrb;
